export type Grade = 'A' | 'B' | 'C' | 'D' | 'E'

// q1〜q30（6領域 × 5問）。値は選択肢の位置（1〜5）。
export type Answers = Record<string, number>

export interface AssessmentQuestion {
  text: string
  options: string[]
}

export interface AssessmentDomain {
  name: string
  desc: string
  points: string[]
  questions: AssessmentQuestion[]
  feedback: Record<Grade, string>
  training: string[]
  priorityDesc: string
  priorityActions: string[]
}

export interface AssessmentLevel {
  min: number
  max: number
  phase: number
  name: string
  copy: string
  color: string
  desc: string
}

export interface DomainScore {
  name: string
  score: number
  grade: Grade
}

export interface PriorityDomain {
  rank: number
  name: string
  desc: string
  actions: string[]
}

export interface TrainingGroup {
  name: string
  items: string[]
}

export interface JudgeResult {
  totalScore: number
  phase: number
  phaseName: string
  phaseCopy: string
  phaseColor: string
  phaseDesc: string
  domainScores: DomainScore[]
  priorityDomains: PriorityDomain[]
  trainings: TrainingGroup[]
}

export function createEmptyAnswers(domainCount: number, questionsPerDomain: number): Answers {
  const answers: Answers = {}
  for (let i = 0; i < domainCount * questionsPerDomain; i++) {
    answers[`q${i + 1}`] = 0
  }
  return answers
}
